import { IComponente, IAtributosMapa, AbstractLayer, 
  GisLabService, DatosService, tipoMapa, Marcador } from 'gis-lib-core';
import { Component, OnInit, Input } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-mapa',
  templateUrl: './gl-map-google.component.html',
  styleUrls: ['./gl-map-google.component.css']
})

export class GlMapGoogleComponent implements OnInit, IComponente {
  @Input() tipo: any;
  @Input() data: IAtributosMapa;

  public capaActiva: AbstractLayer; // Capa activa actual del mapa

  // -----------------------------------------------------------------

  constructor(private gislab: GisLabService, private ds: DatosService, private http: HttpClient) {}

  ngOnInit() {
    this.inicializarMapaPpal();

    // Pendiente del evento de seleccion de capas
    this.gislab.selCapa.subscribe(nombre => {
      this.activarCapa(nombre);
    });
  }

  public async inicializarMapaPpal() {
    if (!this.data) { // Si los datos no vienen de otro sitio
      this.data = {
        listaDeCapas: [],
        opciones: this.gislab.opcionesGis.opcionesMapa,
        tipoMapa: tipoMapa.mapaPpal
      };
      await this.ds.inicializarBaseDatos();
      // AÃ±adir las capas
      this.data.listaDeCapas = this.gislab.opcionesGis.listaCapas;
      this.activarCapa(this.gislab.opcionesGis.capaActiva); // Activar la capa por defecto
    }
  }

  hayMarcadores(): boolean {
    if (this.capaActiva) {
      return (this.capaActiva.getMarkers().length > 0);
    } else {
      return false;
    }
  }

  // Activa una capa del mapa
  async activarCapa(nombre: string) {
    if (this.data.listaDeCapas.length > 0) {
      let capaActivada = false;
      for (const c of this.data.listaDeCapas) {
        if (c.getNombreCapa() === nombre) {
          await c.GenerarGeo();
          this.capaActiva = c;
          capaActivada = true;
          break;
        }
      }
      if (!capaActivada) {
        console.log('No existe la capa ' + nombre + ' ,y no se puede activar...');
      }
    }
  }

  // al hacer click en una entidad abro la ficha que corresponde a esa entidad
  clickEntidad(capa: AbstractLayer, m: Marcador) {
    this.gislab.mostrarInfoEntidad(capa, m);
  }

  // Al hacer click en el mapa cierra el slidePanel
  clickMap() {
    this.gislab.cerrarPanelLateral();
  }
}
